import { render, staticRenderFns } from "./SaveImageButton.vue?vue&type=template&id=4f180611&scoped=true&"
import script from "./SaveImageButton.vue?vue&type=script&lang=js&"
export * from "./SaveImageButton.vue?vue&type=script&lang=js&"
import style0 from "./SaveImageButton.vue?vue&type=style&index=0&id=4f180611&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f180611",
  null
  
)

export default component.exports